import { Collapse, Grid, List } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { isModuleVisibleToUser } from 'components/Sidebar/utils/SidebarRouteLinkHelper';
import { memo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelectUser } from 'redux/User/selectors';
import { WellFullDetailsDTO } from 'types/well';
import { InnerWellboreWithWellInfo } from 'types/wellbore';

import styles from '../../Sidebar.module.scss';
import { SidebarRoute } from '../../utils/RouteLinks';
import SubRouteLink from '../SubRouteLink';

type SidebarRouteProps = {
  name: string;
  routes: SidebarRoute[];
  well?: WellFullDetailsDTO;
  wellbore?: InnerWellboreWithWellInfo;
};

const SidebarRouteLink = ({ name, well, wellbore, routes }: SidebarRouteProps): JSX.Element => {
  const user = useSelectUser();
  const [isOpen, setOpen] = useState(true);

  const onCollapseRoutes = () => setOpen(prevState => !prevState);
  const ArrowIcon = isOpen ? KeyboardArrowDownIcon : ChevronRightIcon;

  return isModuleVisibleToUser(user, routes) ? (
    <div className={styles.routesLink}>
      <Grid
        container
        alignItems="center"
        onClick={onCollapseRoutes}
        className={styles.clickableRoute}
      >
        <ArrowIcon className={styles.linkIcon} />
        <span className={styles.linkTitle}>
          <FormattedMessage id={name} />
        </span>
      </Grid>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {routes
            .filter(route => route.isHidden !== true)
            .map(route => (
              <SubRouteLink
                key={route.name}
                well={well}
                wellbore={wellbore}
                user={user}
                route={route}
              />
            ))}
        </List>
      </Collapse>
    </div>
  ) : (
    <></>
  );
};

export default memo(SidebarRouteLink);
